<template>
  <span>
    <span style="color: #ffa600; text-shadow: 0px 0px 2px #000">
      {{ showText }}
      &nbsp;
      {{ showExtendValue ? showExtendValue : "" }}
    </span>
    <div
      v-if="show === 1"
      class="c-flash_icon c-flash_icon--success animate c-check-font"
    >
      <span class="line tip"></span><span class="line long"></span>
      <!-- <div class="placeholder"></div> -->
      <!-- <div class="fix"></div> -->
    </div>
    <div
      v-else-if="show === 0"
      class="c-flash_icon c-flash_icon--error animate c-check-font"
      style="margin: -5px -1px 0 0"
    >
      <span style="color: #ffa600">?</span>
    </div>
    <div
      v-else-if="show === -1"
      class="c-flash_icon c-flash_icon--error animate c-check-font"
    >
      <span class="x-mark"
        ><span class="line left"></span><span class="line right"></span
      ></span>
    </div>
  </span>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
export default {
  mixins: [mainCommon],
  props: ["show", "showText", "showExtendValue"],
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
<style scoped>
/* success & error */
.c-check-font {
  font-size: 28px;
}
.c-flash_icon {
  width: 1em;
  height: 1em;
  border: 0.1em solid transparent;
  border-radius: 50%;
  margin: 0 auto;
  padding: 0;
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  top: -4px;
  right: 0;
}
.c-flash_icon.c-flash_icon--error .x-mark {
  position: absolute;
  font-size: 0.5em;
  height: 1em;
  width: 1em;
  top: 0.3em;
  left: 0.3em;
}
.c-flash_icon.c-flash_icon--error .line {
  position: absolute;
  height: 0.2em;
  width: 1.2em;
  background-color: #ff2e00;
  display: block;
  top: 0.4em;
  border-radius: 0.025em;
}
.c-flash_icon.c-flash_icon--error .line.left {
  transform: rotate(45deg);
  left: -0.1em;
}
.c-flash_icon.c-flash_icon--error .line.right {
  transform: rotate(-45deg);
  right: -0.1em;
}
.c-flash_icon.c-flash_icon--error.animate {
  animation: animate-error-icon 0.5s;
}
.c-flash_icon.c-flash_icon--error.animate .x-mark {
  animation: animate-x-mark 0.5s;
}
.c-flash_icon.c-flash_icon--success::before {
  border-radius: 1em 0 0 1em;
  width: 0.5em;
  top: 0.2125em;
  left: -0.15em;
  transform: rotate(-45deg);
}
.c-flash_icon.c-flash_icon--success::after {
  border-radius: 0 1em 1em 0;
  top: 0.03em;
  left: 0.265em;
  transform: rotate(-45deg);
  transform-origin: 0 0.5em;
}
.c-flash_icon.c-flash_icon--success .placeholder {
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: absolute;
  left: -0.1em;
  top: -0.1em;
  z-index: 2;
}
.c-flash_icon.c-flash_icon--success .fix {
  width: 0.1em;
  height: 1em;
  background-color: #fff;
  position: absolute;
  left: 0.175em;
  top: 0.05em;
  z-index: 1;
  transform: rotate(-45deg);
}
.c-flash_icon.c-flash_icon--success .line {
  height: 0.1em;
  background-color: #54ff00;
  display: block;
  border-radius: 0.025em;
  position: absolute;
  z-index: 2;
}
.c-flash_icon.c-flash_icon--success .line.tip {
  width: 0.3125em;
  left: 0.05em;
  top: 0.475em;
  transform: rotate(45deg);
  background-color: #54ff00;
}
.c-flash_icon.c-flash_icon--success .line.long {
  width: 0.5875em;
  right: 0.05em;
  top: 0.375em;
  transform: rotate(-45deg);
}
.c-flash_icon.c-flash_icon--success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}
.c-flash_icon.c-flash_icon--success.animate .tip {
  animation: animate-success-tip 0.5s;
}
.c-flash_icon.c-flash_icon--success.animate .long {
  animation: animate-success-long 0.5s;
}

@keyframes animate-success-tip {
  0% {
    width: 0;
    left: 0.0125em;
    top: 0.1375em;
  }
  54% {
    width: 0;
    left: 0.0125em;
    top: 0.1375em;
  }
  70% {
    width: 0.475em;
    left: -0.1em;
    top: 0.4em;
  }
  84% {
    width: 0.2375em;
    left: 0.12em;
    top: 0.5em;
  }
  100% {
    width: 0.3125em;
    left: 0.05em;
    top: 0.475em;
  }
}
@keyframes animate-success-long {
  0% {
    width: 0;
    right: 0.55em;
    top: 0.575em;
  }
  65% {
    width: 0;
    right: 0.55em;
    top: 0.575em;
  }
  84% {
    width: 0.65em;
    right: 0;
    top: 0.35em;
  }
  100% {
    width: 0.5875em;
    right: 0.05em;
    top: 0.375em;
  }
}
@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
@keyframes animate-x-mark {
  0% {
    transform: scale(0.4);
    margin-top: 0.325em;
    opacity: 0;
  }
  50% {
    transform: scale(0.4);
    margin-top: 0.325em;
    opacity: 0;
  }
  80% {
    transform: scale(1.15);
    margin-top: -0.075em;
  }
  100% {
    transform: scale(1.15);
    margin-top: 0;
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/SuccErrMark.vue